import { cn } from '@/lib/utils';

interface FormSidebarItemProps {
  href: string;
  title: string;
  isActive?: boolean;
  isCompleted?: boolean;
  isDisabled?: boolean;
  className?: string;
}

export const FormSidebarItem = ({
  href,
  title,
  isActive = false,
  isCompleted = false,
  isDisabled = false,
  className
}: FormSidebarItemProps) => {
  // Determine the opacity based on state
  const getOpacity = () => {
    if (isActive) return 'opacity-100';
    if (isCompleted) return 'opacity-70';
    return 'opacity-40';
  };

  // Determine the dot color based on state
  const getDotColor = () => {
    if (isActive) return 'bg-white';
    if (isCompleted) return 'bg-green-400';
    return 'bg-gray-600';
  };

  return (
    <a
      href={href}
      className={cn(
        'flex items-center gap-3 rounded-lg px-2 py-2 font-semibold text-lime hover:bg-white/5',
        getOpacity(),
        isDisabled && 'pointer-events-none',
        className
      )}
    >
      <div className={cn('h-2 w-2 rounded-full', getDotColor())} />
      <span className="text-sm">{title}</span>
    </a>
  );
};
